import { Toast } from 'antd-mobile';
const HdlToast = {
  success(content: any, duration?: any, onClose?: any) {
    if (!duration) duration = 1500;
    Toast.show({
      icon: 'success',
      content,
      duration,
      afterClose: onClose,
    });
  },
  fail(content: any, duration?: any, onClose?: any) {
    if (!duration) duration = 1500;
    Toast.show({
      icon: 'fail',
      content,
      duration,
      afterClose: onClose,
    });
  },
  info(content: any, duration?: any, onClose?: any, mask?: any) {
    if (!duration) duration = 1500;
    if (!mask) mask = false;
    Toast.show({
      content,
      duration,
      afterClose: onClose,
      maskClickable: false,
    });
  },
  loading(content: any, duration?: any, onClose?: any, mask?: any) {
    if (!duration) duration = 1500;
    if (!mask) mask = false;
    Toast.show({
      icon: 'loading',
      content,
      duration,
      afterClose: onClose,
    });
  },
  clear() {
    Toast.clear();
  },
};

export default HdlToast;
